import { format, subMonths, addMonths } from "date-fns";
import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
} from "@mui/icons-material";
import { Button } from "@components/Helpers/UIComponents";
import { MonthNavigationProps } from "@interfaces/uiElementTypes";

/**
 * Renders the month navigation component. It allows you to navigate between months.
 * არენდერს თვის ნავიგაციის კომპონენტს. ის თვეებს შორის გადასვლას უზრუნველყოფს.
 *
 * @param currentMonth - The currently selected month.
 * @param setCurrentMonth - A function to update the currently selected month.
 * @param locale - The locale to use for formatting the month.
 * @returns The rendered month navigation component.
 */

export const MonthNavigation: React.FC<MonthNavigationProps> = ({
  currentMonth,
  setCurrentMonth,
  locale,
}) => (
  <div className="mb-0 flex w-full items-center justify-between gap-3 md:mb-4">
    <Button
      className="nav_button h-[40px] w-[40px]"
      onClick={() => setCurrentMonth(subMonths(currentMonth, 1))}
    >
      <ArrowBackIosRounded sx={{ fontSize: 20 }} className="" />
    </Button>
    <span className="nav_button h-[40px] flex-grow">
      {format(currentMonth, "MMMM, yyyy", { locale })}
    </span>
    <Button
      className="nav_button h-[40px] w-[40px]"
      onClick={() => setCurrentMonth(addMonths(currentMonth, 1))}
    >
      <ArrowForwardIosRounded sx={{ fontSize: 20 }} className="" />
    </Button>
  </div>
);
